import type { ApiResponse } from "@/types";

import { BaseApi } from "../base.api";
import type { CreateSectionData, Section, UpdateSectionData } from "./types";

export * from "./types";

/** Bo'limlar API — backend'dagi `SectionsController` ning ko'zgusi. */
export class SectionsApi extends BaseApi {
  private readonly baseUrl: string = "/sections";

  /** Kursning barcha bo'limlari, tartiblangan holda. */
  getByCourse(courseId: number) {
    return this.request.get<Section[], ApiResponse<Section[]>>(this.baseUrl, {
      params: { courseId },
    });
  }

  create(data: CreateSectionData) {
    return this.request.post<Section, ApiResponse<Section>>(this.baseUrl, data);
  }

  update(id: number, data: UpdateSectionData) {
    return this.request.patch<Section, ApiResponse<Section>>(`${this.baseUrl}/${id}`, data);
  }

  remove(id: number) {
    return this.request.delete<null, ApiResponse<null>>(`${this.baseUrl}/${id}`);
  }

  /**
   * Yangi tartibni saqlaydi.
   *
   * Payload — TO'LIQ birodarlar ro'yxati (`sectionIds`), qisman emas. Eski
   * ilova faqat siljigan ikkita elementni yuborar va backend qolganlarining
   * `order` ini o'zgarishsiz qoldirar edi — natijada tartib buzilardi.
   */
  reorder(sectionIds: number[]) {
    return this.request.patch<Section[], ApiResponse<Section[]>>(`${this.baseUrl}/reorder`, {
      sectionIds,
    });
  }

  /** Bo'limning o'quvchiga ko'rinishini yoqadi/o'chiradi. */
  togglePublish(id: number) {
    return this.request.patch<Section, ApiResponse<Section>>(
      `${this.baseUrl}/${id}/toggle-publish`,
    );
  }

  /** Bo'limni darslari bilan nusxalaydi. */
  duplicate(id: number) {
    return this.request.post<Section, ApiResponse<Section>>(`${this.baseUrl}/${id}/duplicate`);
  }
}

export const sectionsApi = new SectionsApi();
